import type { CmChecklist } from '@luxuryescapes/contract-svc-offer';

// Snapshot of the Sales Ops Policy Bible chain/geo table. svc-offer evaluates against its own
// copy; this one backs PolicyBibleReferenceDialog and resolves the matched rule for display.

export type PolicyBibleCampaignRule = {
  chain: string;
  dateChangeAllowedDays?: number;
  // Policy Bible "Educational Package Clause" (prize) is Enabled.
  educationalPackageClause: boolean;
  geo: string;
  numberOfDateChanges?: string;
};

export const POLICY_BIBLE_CAMPAIGN_RULES: Array<PolicyBibleCampaignRule> = [
  { chain: 'Accor', educationalPackageClause: false, geo: 'Intl', dateChangeAllowedDays: 45, numberOfDateChanges: '1' },
  {
    chain: 'Accor',
    educationalPackageClause: false,
    geo: 'Australia',
    dateChangeAllowedDays: 45,
    numberOfDateChanges: '1',
  },
  {
    chain: 'Ascott',
    educationalPackageClause: true,
    geo: 'Australia',
    dateChangeAllowedDays: 21,
    numberOfDateChanges: 'Unlimited',
  },
  {
    chain: 'Ascott',
    educationalPackageClause: true,
    geo: 'Intl',
    dateChangeAllowedDays: 21,
    numberOfDateChanges: 'Unlimited',
  },
  {
    chain: 'Ayana',
    educationalPackageClause: true,
    geo: 'Intl',
    dateChangeAllowedDays: 21,
    numberOfDateChanges: 'Unlimited',
  },
  {
    chain: 'Clermont',
    educationalPackageClause: true,
    geo: 'Intl',
    dateChangeAllowedDays: 21,
    numberOfDateChanges: 'Unlimited',
  },
  {
    chain: 'EVT',
    educationalPackageClause: true,
    geo: 'Australia',
    dateChangeAllowedDays: 21,
    numberOfDateChanges: 'Unlimited',
  },
  {
    chain: 'EVT',
    educationalPackageClause: true,
    geo: 'Intl',
    dateChangeAllowedDays: 21,
    numberOfDateChanges: 'Unlimited',
  },
  {
    chain: 'Grecotel',
    educationalPackageClause: false,
    geo: 'Intl',
    dateChangeAllowedDays: 21,
    numberOfDateChanges: 'Unlimited',
  },
  {
    chain: 'Highgate',
    educationalPackageClause: false,
    geo: 'Intl',
    dateChangeAllowedDays: 30,
    numberOfDateChanges: '1',
  },
  { chain: 'Hilton', educationalPackageClause: false, geo: 'Intl' },
  { chain: 'Hilton', educationalPackageClause: false, geo: 'Australia' },
  {
    chain: 'Hyatt',
    educationalPackageClause: true,
    geo: 'Australia',
    dateChangeAllowedDays: 45,
    numberOfDateChanges: '1',
  },
  { chain: 'Hyatt', educationalPackageClause: true, geo: 'Intl', dateChangeAllowedDays: 45, numberOfDateChanges: '1' },
  {
    chain: 'IHG',
    educationalPackageClause: false,
    geo: 'Australia',
    dateChangeAllowedDays: 21,
    numberOfDateChanges: 'Unlimited',
  },
  {
    chain: 'IHG',
    educationalPackageClause: false,
    geo: 'Intl',
    dateChangeAllowedDays: 21,
    numberOfDateChanges: 'Unlimited',
  },
  { chain: 'Kerzner', educationalPackageClause: false, geo: 'Australia' },
  { chain: 'Kerzner', educationalPackageClause: false, geo: 'Intl' },
  {
    chain: 'Kimpton',
    educationalPackageClause: false,
    geo: 'Intl',
    dateChangeAllowedDays: 30,
    numberOfDateChanges: '1',
  },
  { chain: 'Lalit', educationalPackageClause: false, geo: 'Intl' },
  {
    chain: 'Langham',
    educationalPackageClause: true,
    geo: 'Australia',
    dateChangeAllowedDays: 45,
    numberOfDateChanges: '1',
  },
  {
    chain: 'Langham',
    educationalPackageClause: true,
    geo: 'Intl',
    dateChangeAllowedDays: 45,
    numberOfDateChanges: '1',
  },
  { chain: 'Mantra', educationalPackageClause: false, geo: 'Australia' },
  {
    chain: 'Marriott',
    educationalPackageClause: false,
    geo: 'Intl/Aus',
    dateChangeAllowedDays: 21,
    numberOfDateChanges: 'Unlimited',
  },
  { chain: 'Melia', educationalPackageClause: false, geo: 'Intl' },
  { chain: 'Minor', educationalPackageClause: false, geo: 'Australia' },
  { chain: 'Minor', educationalPackageClause: false, geo: 'Intl' },
  {
    chain: 'Mulia',
    educationalPackageClause: false,
    geo: 'Intl',
    dateChangeAllowedDays: 21,
    numberOfDateChanges: 'Unlimited',
  },
  { chain: 'Nomade', educationalPackageClause: true, geo: 'Intl', dateChangeAllowedDays: 21, numberOfDateChanges: '2' },
  {
    chain: 'Oberoi',
    educationalPackageClause: false,
    geo: 'Intl',
    dateChangeAllowedDays: 21,
    numberOfDateChanges: 'Unlimited',
  },
  {
    chain: 'Oberoi',
    educationalPackageClause: false,
    geo: 'India',
    dateChangeAllowedDays: 21,
    numberOfDateChanges: 'Unlimited',
  },
  {
    chain: 'Pro Invest',
    educationalPackageClause: true,
    geo: 'Australia',
    dateChangeAllowedDays: 21,
    numberOfDateChanges: 'Unlimited',
  },
  {
    chain: 'Pro Invest',
    educationalPackageClause: true,
    geo: 'Intl',
    dateChangeAllowedDays: 21,
    numberOfDateChanges: 'Unlimited',
  },
  { chain: 'RACV', educationalPackageClause: false, geo: 'Australia' },
  { chain: 'Shangri La', educationalPackageClause: false, geo: 'Intl' },
  { chain: 'Shangri La', educationalPackageClause: false, geo: 'Australia' },
  {
    chain: 'Standard',
    educationalPackageClause: true,
    geo: 'Australia',
    dateChangeAllowedDays: 21,
    numberOfDateChanges: 'Unlimited',
  },
  {
    chain: 'Standard',
    educationalPackageClause: true,
    geo: 'India',
    dateChangeAllowedDays: 21,
    numberOfDateChanges: 'Unlimited',
  },
  {
    chain: 'Standard',
    educationalPackageClause: true,
    geo: 'International',
    dateChangeAllowedDays: 21,
    numberOfDateChanges: 'Unlimited',
  },
  {
    chain: 'Standard',
    educationalPackageClause: true,
    geo: 'USA',
    dateChangeAllowedDays: 21,
    numberOfDateChanges: 'Unlimited',
  },
  {
    chain: 'Standard (GOLF wholesale)',
    educationalPackageClause: true,
    geo: 'Intl',
    dateChangeAllowedDays: 21,
    numberOfDateChanges: 'Unlimited',
  },
  {
    chain: 'Standard (GOLF WHOLESALE)',
    educationalPackageClause: true,
    geo: 'Australia',
    dateChangeAllowedDays: 21,
    numberOfDateChanges: 'Unlimited',
  },
  { chain: 'TFE', educationalPackageClause: false, geo: 'Intl', dateChangeAllowedDays: 45, numberOfDateChanges: '1' },
  {
    chain: 'TFE',
    educationalPackageClause: false,
    geo: 'Australia',
    dateChangeAllowedDays: 45,
    numberOfDateChanges: '1',
  },
  {
    chain: 'The Star',
    educationalPackageClause: false,
    geo: 'Australia',
    dateChangeAllowedDays: 21,
    numberOfDateChanges: '1',
  },
  { chain: 'Two Roads', educationalPackageClause: false, geo: 'Intl' },
  { chain: 'Vinpearl', educationalPackageClause: false, geo: 'Intl' },
];

// Normalized LE_Hotel_Chains__c picklist value -> normalized Policy Bible chain key, for values that don't match exactly.
export const POLICY_BIBLE_CHAIN_ALIASES: Record<string, string> = {
  'standard template': 'standard',
  marriot: 'marriott',
  'clermont hotels': 'clermont',
  'golf wholesale': 'standard (golf wholesale)',
  glh: 'clermont',
};

// Normalized real geo value -> normalized Policy Bible geo bucket.
export const POLICY_BIBLE_GEO_ALIASES: Record<string, string> = {
  au: 'australia',
  aus: 'australia',
  australia: 'australia',
  intl: 'intl',
  international: 'intl',
  'intl/aus': 'intl/australia',
  'intl aus': 'intl/australia',
  'international/australia': 'intl/australia',
  'international australia': 'intl/australia',
  us: 'usa',
  usa: 'usa',
  'united states': 'usa',
  'united states of america': 'usa',
  nz: 'intl',
  'new zealand': 'intl',
};

// The dialog highlights the matched rule by reference, so resolve back to the shared table entry.
export function findPolicyBibleRule(match: CmChecklist.PolicyBibleMatch | null): PolicyBibleCampaignRule | undefined {
  if (!match) {
    return undefined;
  }

  return POLICY_BIBLE_CAMPAIGN_RULES.find((rule) => rule.chain === match.chain && rule.geo === match.geo);
}
